import React from "react";

function Delhi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7 4.99712V3.87536C7 3.87536 11.3478 1.9058 17 3.87536V5L7 4.99712Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M7 5H18V6H7V5Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M6 6H19V8H6V6Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M4 8H20"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M5 8H19V21H5V8Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M7 12H9V21H7V12Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M8 9.61538C8.07607 9.61538 8.15043 9.63794 8.21368 9.6802C8.27693 9.72247 8.32623 9.78253 8.35534 9.85281C8.38445 9.92309 8.39207 10.0004 8.37722 10.075C8.36238 10.1496 8.32575 10.2182 8.27196 10.272C8.21817 10.3258 8.14964 10.3624 8.07503 10.3772C8.00043 10.3921 7.92309 10.3844 7.85281 10.3553C7.78254 10.3262 7.72247 10.2769 7.6802 10.2137C7.63794 10.1504 7.61539 10.0761 7.61539 10C7.61539 9.89799 7.65591 9.80016 7.72804 9.72804C7.80017 9.65591 7.89799 9.61538 8 9.61538ZM8 9C7.80222 9 7.60888 9.05865 7.44443 9.16853C7.27998 9.27841 7.15181 9.43459 7.07612 9.61732C7.00043 9.80004 6.98063 10.0011 7.01922 10.1951C7.0578 10.3891 7.15304 10.5673 7.29289 10.7071C7.43275 10.847 7.61093 10.9422 7.80491 10.9808C7.99889 11.0194 8.19996 10.9996 8.38268 10.9239C8.56541 10.8482 8.72159 10.72 8.83147 10.5556C8.94135 10.3911 9 10.1978 9 10C9 9.73478 8.89464 9.48043 8.70711 9.29289C8.51957 9.10536 8.26522 9 8 9Z"
        fill="#17142A"
      />
      <path
        d="M16 12H18V21H16V12Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M16.9938 9.61539C17.0699 9.61539 17.1443 9.63795 17.2075 9.68021C17.2708 9.72247 17.3201 9.78254 17.3492 9.85282C17.3783 9.9231 17.3859 10.0004 17.3711 10.075C17.3562 10.1497 17.3196 10.2182 17.2658 10.272C17.212 10.3258 17.1435 10.3624 17.0689 10.3772C16.9943 10.3921 16.9169 10.3845 16.8467 10.3554C16.7764 10.3262 16.7163 10.2769 16.6741 10.2137C16.6318 10.1504 16.6092 10.0761 16.6092 10C16.6092 9.898 16.6498 9.80017 16.7219 9.72804C16.794 9.65591 16.8918 9.61539 16.9938 9.61539ZM16.9938 9C16.7963 9.00122 16.6036 9.0609 16.44 9.17152C16.2763 9.28213 16.1491 9.43874 16.0744 9.62157C15.9996 9.8044 15.9807 10.0053 16.02 10.1988C16.0592 10.3924 16.155 10.57 16.2951 10.7093C16.4352 10.8485 16.6134 10.9431 16.8072 10.9812C17.001 11.0193 17.2017 10.9992 17.3841 10.9233C17.5665 10.8474 17.7223 10.7193 17.8319 10.5549C17.9415 10.3906 18 10.1975 18 10C18 9.73479 17.8946 9.48043 17.7071 9.2929C17.5196 9.10536 17.2652 9 17 9H16.9938Z"
        fill="#17142A"
      />
      <path
        d="M14.7273 21.0262V11.792C14.7386 11.4567 14.6824 11.1225 14.5619 10.8093C14.4415 10.4962 14.2592 10.2105 14.026 9.96921C13.7928 9.72796 13.5135 9.53612 13.2046 9.40509C12.8957 9.27407 12.5636 9.20654 12.2281 9.20654C11.8925 9.20654 11.5604 9.27407 11.2515 9.40509C10.9427 9.53612 10.6633 9.72796 10.4301 9.96921C10.1969 10.2105 10.0146 10.4962 9.89417 10.8093C9.7737 11.1225 9.71748 11.4567 9.72886 11.792V21.0262H14.7273Z"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M4.46094 13.9097H6.10405"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M4.46094 17.248H6.10405"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M9.06531 13.9097H10.7084"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M9.06531 17.248H10.7084"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M13.7837 13.9097H15.4268"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M13.7837 17.248H15.4268"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M18.2732 13.9097H19.9163"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
      <path
        d="M18.2732 17.248H19.9163"
        stroke="#17142A"
        strokeWidth="0.429611"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoDelhi = React.memo(Delhi);
export default MemoDelhi;
